import React from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './FilterBar.module.scss';

const FILTER_PARAMS = ['price_min', 'price_max', 'in_stock', 'param'];

const parseParamString = (str) => {
    const result = {};
    if (!str) return result;
    for (const pair of str.split('|')) {
        const idx = pair.indexOf(':');
        if (idx === -1) continue;
        const label = pair.slice(0, idx).trim();
        const value = pair.slice(idx + 1).trim();
        if (!label || !value) continue;
        if (!result[label]) result[label] = [];
        if (!result[label].includes(value)) result[label].push(value);
    }
    return result;
};

const serializeParam = (obj) => {
    const pairs = [];
    for (const [label, values] of Object.entries(obj)) {
        for (const v of values) {
            if (v) pairs.push(`${label}:${v}`);
        }
    }
    return pairs.join('|');
};

const FilterBar = ({ availableFilters = [] }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const setParam = (key, value) => {
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            if (value === '' || value === null || value === undefined) {
                next.delete(key);
            } else {
                next.set(key, value);
            }
            return next;
        });
    };

    const currentParams = parseParamString(searchParams.get('param') || '');

    const toggleParam = (label, value) => {
        const next = {};
        for (const [k, v] of Object.entries(currentParams)) {
            next[k] = [...v];
        }
        if (!next[label]) next[label] = [];
        const idx = next[label].indexOf(value);
        if (idx !== -1) {
            next[label].splice(idx, 1);
            if (next[label].length === 0) delete next[label];
        } else {
            next[label].push(value);
        }
        const serialized = serializeParam(next);
        setParam('param', serialized || null);
    };

    const handleReset = () => {
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            FILTER_PARAMS.forEach((k) => next.delete(k));
            return next;
        });
    };

    return (
        <div className={styles.filterBar}>
            <h3 className={styles.filterBar__title}>Фильтры</h3>

            <div className={styles.filterBar__section}>
                <span className={styles.filterBar__groupTitle}>Цена</span>
                <div className={styles.filterBar__priceRow}>
                    <input
                        type="number"
                        min="0"
                        placeholder="от"
                        className={styles.filterBar__input}
                        value={searchParams.get('price_min') || ''}
                        onChange={(e) => setParam('price_min', e.target.value || null)}
                    />
                    <input
                        type="number"
                        min="0"
                        placeholder="до"
                        className={styles.filterBar__input}
                        value={searchParams.get('price_max') || ''}
                        onChange={(e) => setParam('price_max', e.target.value || null)}
                    />
                </div>
            </div>

            <div className={styles.filterBar__section}>
                <label className={styles.filterBar__checkboxLabel}>
                    <input
                        type="checkbox"
                        checked={searchParams.get('in_stock') === 'true'}
                        onChange={(e) => setParam('in_stock', e.target.checked ? 'true' : null)}
                    />
                    Только в наличии
                </label>
            </div>

            {availableFilters.map(({ label, values }) => (
                <div key={label} className={styles.filterBar__section}>
                    <span className={styles.filterBar__groupTitle}>{label}</span>
                    {values.length <= 6 ? (
                        <div className={styles.filterBar__checkboxGroup}>
                            {values.map((value) => (
                                <label key={value} className={styles.filterBar__checkboxLabel}>
                                    <input
                                        type="checkbox"
                                        checked={currentParams[label]?.includes(value) || false}
                                        onChange={() => toggleParam(label, value)}
                                    />
                                    {value}
                                </label>
                            ))}
                        </div>
                    ) : (
                        <div className={styles.filterBar__chips}>
                            {values.map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        currentParams[label]?.includes(value)
                                            ? styles.chipActive
                                            : styles.chip
                                    }
                                    onClick={() => toggleParam(label, value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            ))}

            <button type="button" onClick={handleReset} className={styles.filterBar__reset}>
                Сбросить фильтры
            </button>
        </div>
    );
};

export default FilterBar;
